import { toLocalCalendarDay } from "../../../../utils/datetime/core";

const DAY_MS = 86400000;

/**
 * True when adjacent timeline columns need the stronger weekend/week separator.
 *
 * This only covers hidden-weekend gaps (Fri → Mon). When weekends are shown,
 * adjacent days keep the standard thin divider.
 *
 * @param {Date|null|undefined} prevDay
 * @param {Date|null|undefined} currDay
 * @returns {boolean}
 */
export function isScheduleWeekGapDivider(prevDay, currDay) {
  if (!prevDay || !currDay) {
    return false;
  }
  const a = toLocalCalendarDay(prevDay).getTime();
  const b = toLocalCalendarDay(currDay).getTime();
  const gapDays = (b - a) / DAY_MS;
  if (gapDays > 1) {
    return true;
  }
  return false;
}
